import api from './api';
import TokenService from './TokenService';
import PushNotificationService from './PushNotificationService';

export default class UserService {
    static async login(phone, password) {
        const response = await api.post('/api/v1/staff/auth/authenticate', { phone, password });
        if (response.data?.access_token) {
            TokenService.setUserInfo(response.data.access_token);
        }
        return response.data;
    }

    static isAuthenticated() {
        return !!TokenService._getInfo() && !TokenService.isExpired();
    }

    static async logout() {
        // Drop this device's push subscription while the token is still valid,
        // so a logged-out device (or the next user on it) stops getting notifications
        await PushNotificationService.unsubscribe();
        try {
            await api.post('/api/v1/auth/logout');
        } catch {
            // proceed even if server is unreachable
        }
        TokenService.clearUserInfo();
        localStorage.removeItem('role');
    }

    // payload: { phone } или { email } — ровно одно из двух полей.
    static async requestPasswordReset(payload) {
        const { data } = await api.post('/api/v1/auth/password-reset/request', payload);
        return data;
    }

    // payload: { phone, otp } или { email, otp } — ровно одно из phone/email.
    static async verifyResetOtp(payload) {
        const { data } = await api.post('/api/v1/auth/password-reset/verify-otp', payload);
        return data;
    }

    static async confirmPasswordReset(resetToken, newPassword) {
        const { data } = await api.post('/api/v1/auth/password-reset/confirm', { resetToken, newPassword });
        return data;
    }

    static async changePassword(currentPassword, newPassword) {
        const { data } = await api.patch('/api/v1/auth/change-password', { currentPassword, newPassword });
        return data;
    }

    // { email: string | null } — текущий recovery-email авторизованного юзера.
    static async getRecoveryEmail() {
        const { data } = await api.get('/api/v1/users/recovery-email');
        return data;
    }

    static async setRecoveryEmail(email) {
        return api.put('/api/v1/users/recovery-email', { email });
    }
}
